import { Routes, Route } from 'react-router-dom'

import AddAlertDescription from 'pages/AddAlertDescription'
import AlertLookup from 'pages/AlertLookup'
import EditAlertDescription from 'pages/EditAlertDescription'
import NotFound from 'pages/NotFound'

import { useSessionContext } from 'hooks/SessionContext'

const AlertsRouter = () => {
  const { session: { isAlarmDescriptionAdmin: isAlertGuideAdmin } } = useSessionContext()
  return (
    <Routes>
      <Route path="new" element={<AddAlertDescription />} />
      {isAlertGuideAdmin && <Route path=":alertCode/edit" element={<EditAlertDescription />} />}
      <Route index element={<AlertLookup />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AlertsRouter
